export default import.meta.ROLLDOWN_FILE_URL_BMlLyP$j8YFMgEE5MoRYvw